'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

const links = [
  { href: '/', label: 'Accueil' },
  { href: '/transactions', label: 'Ajouter' },
  { href: '/calendar', label: 'Mois' },
  { href: '/budgets', label: 'Budgets' },
  { href: '/stats', label: 'Stats' },
  { href: '/settings', label: 'Réglages' },
];

export default function BottomNavigation({ active }: { active: string }) {
  const pathname = usePathname();

  return (
    <nav className="no-print mx-auto mt-7 w-full max-w-3xl rounded-2xl border border-slate-800 bg-slate-950/95 shadow-sm">
      <div className="grid grid-cols-6 gap-0.5 px-1.5 py-2 min-[380px]:gap-1 min-[380px]:px-2">
        {links.map((link) => {
          const isActive = pathname === link.href || active === link.href;

          return (
            <Link
              key={link.href}
              href={link.href}
              aria-current={isActive ? 'page' : undefined}
              className={`flex min-h-12 min-w-0 flex-col items-center justify-center rounded-xl px-0.5 text-xs font-semibold leading-tight transition min-[380px]:rounded-2xl min-[380px]:px-1 ${
                isActive ? 'bg-brand-500/15 text-brand-300' : 'text-slate-400 hover:bg-slate-900'
              }`}
            >
              <span className={`mb-1 h-1.5 w-1.5 rounded-full ${isActive ? 'bg-brand-400' : 'bg-slate-700'}`} />
              <span className="truncate">{link.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
